import React from 'react';
import './index.css'
import { Route, Routes } from 'react-router-dom';
import Hero from './components/Hero/Hero';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Gallery from './pages/Gallery/Gallery';
import Volunteer from './pages/Volunteer/Volunteer';
import Contact from './components/Contact/Contact';
import { ContactProvider } from './context/contactContext';
import Blog from './pages/Blog/Blog';
import Services from './pages/Services/Services';
import { DonateProvider } from './context/donateContext';
import Donate from './components/Donate/Donate';
import Post from './pages/Post/Post';
import BlogPanel from './pages/BlogPanel/BlogPanel';
import AdminPanel from './components/AdminPanel/AdminPanel';
import AdminHome from './pages/AdminHome/AdminHome';
import AdminInbox from './pages/Admininbox/AdminInbox';
import AdminApp from './pages/AdminApp/AdminApp';
import AdminGallery from './pages/AdminGallery/AdminGallery';
import Footer from './components/Footer/Footer';
import { MenuProvider } from './context/MenuContext';
import ApplyPage from './components/ApplyPage/ApplyPage';
import TrackApplication from './components/Tracking/Tracking';
import AdminLogin from './components/AdminLogin/AdminLogin';
import PrivateRoute from './components/PrivateRoute/PrivateRote';

const App = () => {
  return (
    <div className='root_container'>
      <ContactProvider>
        <DonateProvider>
          <MenuProvider>
            <Hero/>
              <Contact/>
                <Donate/>
                <Routes>
                  <Route path="/" element={<Home/>}/>
                  <Route path="/about" element={<About/>}/>
                  <Route path="/gallery" element={<Gallery/>}/> 
                  <Route path="/volunteer" element={<Volunteer/>}/> 
                  <Route path="/blog" element={<BlogPanel/>}>
                    <Route path="/blog/" element={<Blog/>}/> 
                    <Route path="/blog/post/:id" element={<Post/>}/> 
                  </Route> 

                  <Route path="/services" element={<Services/>}/>
                  <Route path="/application" element={<ApplyPage/>}/>
                  <Route path="/tracking" element={<TrackApplication/>}/>
                  <Route path="/admin/login" element={<AdminLogin/>}/>

                  <Route path="/admin" element={<PrivateRoute><AdminPanel/></PrivateRoute>}>
                    <Route path="/admin/" element={<PrivateRoute><AdminHome/></PrivateRoute>}/>
                    <Route path="/admin/inbox" element={<PrivateRoute><AdminInbox/></PrivateRoute>}/>
                    <Route path="/admin/applications" element={<PrivateRoute><AdminApp/></PrivateRoute>}/>
                    <Route path="/admin/media" element={<PrivateRoute><AdminGallery/></PrivateRoute>}/>
                  </Route>
                </Routes>
                <Footer/>
            </MenuProvider>
        </DonateProvider>
      </ContactProvider>
    </div>
  );
};

export default App;
